import React, {Component, Fragment} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Helmet} from 'react-helmet'

import ScrollToTop from './ScrollToTop'
import NavBar from './NavBar.js'
import Home from './Home.js'
import Album from './Album'
import FourOhFour from './FourOhFour'
import AlbumList from './AlbumList'

const availableLocales = ['en-US', 'es-MX']
const alternateLocales = currentLocale =>
  availableLocales.filter(locale => locale !== currentLocale)

class App extends Component {
  render () {
    return (
      <Fragment>
        <Helmet>
          <html lang={this.props.lang} />
          {alternateLocales(this.props.locale).map(locale => (
            <link key={locale} rel="alternate" hreflang={locale} href={`/${locale}/`} />
          ))}
        </Helmet>

        <NavBar locale={this.props.locale} />

        <ScrollToTop>
          <Switch>
            <Route exact path='/:locale' component={Home} />
            <Route path='/:locale/albums/:album/:photo' component={Album} />
            <Route path='/:locale/albums/:album' component={Album} />
            <Route path='/:locale/albums' component={AlbumList} />
            <Route component={FourOhFour} />
          </Switch>
        </ScrollToTop>
      </Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js